// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `@charset "UTF-8";
/**
 * @copyright Copyright (c) 2019 John Molakvoæ <skjnldsv@protonmail.com>
 *
 * @author John Molakvoæ <skjnldsv@protonmail.com>
 *
 * @license GNU AGPL version 3 or any later version
 *
 * This program is free software: you can redistribute it and/or modify
 * it under the terms of the GNU Affero General Public License as
 * published by the Free Software Foundation, either version 3 of the
 * License, or (at your option) any later version.
 *
 * This program is distributed in the hope that it will be useful,
 * but WITHOUT ANY WARRANTY; without even the implied warranty of
 * MERCHANTABILITY or FITNESS FOR A PARTICULAR PURPOSE.  See the
 * GNU Affero General Public License for more details.
 *
 * You should have received a copy of the GNU Affero General Public License
 * along with this program. If not, see <http://www.gnu.org/licenses/>.
 *
 */
.material-design-icon[data-v-7b246f90] {
  display: flex;
  align-self: center;
  justify-self: center;
  align-items: center;
  justify-content: center;
}
.native-datetime-picker[data-v-7b246f90] {
  display: flex;
  flex-direction: column;
}
.native-datetime-picker .native-datetime-picker--input[data-v-7b246f90] {
  width: 100%;
  flex: 0 0 auto;
  padding-right: 4px;
}
[data-theme-light] .native-datetime-picker--input[data-v-7b246f90],
[data-themes*=light] .native-datetime-picker--input[data-v-7b246f90] {
  color-scheme: light;
}
[data-theme-dark] .native-datetime-picker--input[data-v-7b246f90],
[data-themes*=dark] .native-datetime-picker--input[data-v-7b246f90] {
  color-scheme: dark;
}
@media (prefers-color-scheme: light) {
  [data-theme-default] .native-datetime-picker--input[data-v-7b246f90],
  [data-themes*=default] .native-datetime-picker--input[data-v-7b246f90] {
    color-scheme: light;
  }
}
@media (prefers-color-scheme: dark) {
  [data-theme-default] .native-datetime-picker--input[data-v-7b246f90],
  [data-themes*=default] .native-datetime-picker--input[data-v-7b246f90] {
    color-scheme: dark;
  }
}
`, "",{"version":3,"sources":["webpack://./node_modules/@nextcloud/vue/dist/assets/NcDateTimePickerNative-DnLJu29_.css"],"names":[],"mappings":"AAAA,gBAAgB;AAChB;;;;;;;;;;;;;;;;;;;;EAoBE;AACF;EACE,aAAa;EACb,kBAAkB;EAClB,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;AACzB;AACA;EACE,aAAa;EACb,sBAAsB;AACxB;AACA;EACE,WAAW;EACX,cAAc;EACd,kBAAkB;AACpB;AACA;;EAEE,mBAAmB;AACrB;AACA;;EAEE,kBAAkB;AACpB;AACA;EACE;;IAEE,mBAAmB;EACrB;AACF;AACA;EACE;;IAEE,kBAAkB;EACpB;AACF","sourcesContent":["@charset \"UTF-8\";\n/**\n * @copyright Copyright (c) 2019 John Molakvoæ <skjnldsv@protonmail.com>\n *\n * @author John Molakvoæ <skjnldsv@protonmail.com>\n *\n * @license GNU AGPL version 3 or any later version\n *\n * This program is free software: you can redistribute it and/or modify\n * it under the terms of the GNU Affero General Public License as\n * published by the Free Software Foundation, either version 3 of the\n * License, or (at your option) any later version.\n *\n * This program is distributed in the hope that it will be useful,\n * but WITHOUT ANY WARRANTY; without even the implied warranty of\n * MERCHANTABILITY or FITNESS FOR A PARTICULAR PURPOSE.  See the\n * GNU Affero General Public License for more details.\n *\n * You should have received a copy of the GNU Affero General Public License\n * along with this program. If not, see <http://www.gnu.org/licenses/>.\n *\n */\n.material-design-icon[data-v-7b246f90] {\n  display: flex;\n  align-self: center;\n  justify-self: center;\n  align-items: center;\n  justify-content: center;\n}\n.native-datetime-picker[data-v-7b246f90] {\n  display: flex;\n  flex-direction: column;\n}\n.native-datetime-picker .native-datetime-picker--input[data-v-7b246f90] {\n  width: 100%;\n  flex: 0 0 auto;\n  padding-right: 4px;\n}\n[data-theme-light] .native-datetime-picker--input[data-v-7b246f90],\n[data-themes*=light] .native-datetime-picker--input[data-v-7b246f90] {\n  color-scheme: light;\n}\n[data-theme-dark] .native-datetime-picker--input[data-v-7b246f90],\n[data-themes*=dark] .native-datetime-picker--input[data-v-7b246f90] {\n  color-scheme: dark;\n}\n@media (prefers-color-scheme: light) {\n  [data-theme-default] .native-datetime-picker--input[data-v-7b246f90],\n  [data-themes*=default] .native-datetime-picker--input[data-v-7b246f90] {\n    color-scheme: light;\n  }\n}\n@media (prefers-color-scheme: dark) {\n  [data-theme-default] .native-datetime-picker--input[data-v-7b246f90],\n  [data-themes*=default] .native-datetime-picker--input[data-v-7b246f90] {\n    color-scheme: dark;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
